import Rete from 'rete'

import RcnTemplate from './RcnTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class RcnComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.RECURRING_NOTIFICATION)
    
    this.data.component = RcnTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.RCN
    this.setConnection()
    
    const rcnInput = new Rete.Input(CONST_SOCKET.RECURRING_NOTIFICATION_INPUT, lang.Rcn_socket_input_reply, this.socket.rcnInput, true)
    const rcnOutput = new Rete.Output(CONST_SOCKET.RECURRING_NOTIFICATION_OUTPUT, lang.Rcn_socket_output_next, this.socket.rcnOutput, false)

    return node
      .addInput(rcnInput)
      .addOutput(rcnOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.RECURRING_NOTIFICATION_OUTPUT] = node.data
  }

  setConnection() {
    // OTN may be connected to:
    this.socket.rcnOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.rcnOutput.combineWith(this.socket.openaiInput)
    this.socket.rcnOutput.combineWith(this.socket.carouselInput)
    this.socket.rcnOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.rcnOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.rcnOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.rcnOutput.combineWith(this.socket.videoInput)
      this.socket.rcnOutput.combineWith(this.socket.audioInput)
      this.socket.rcnOutput.combineWith(this.socket.fileInput)
    }
    
    this.socket.rcnOutput.combineWith(this.socket.ecommerceInput)
    this.socket.rcnOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.rcnOutput.combineWith(this.socket.rcnSingleInput)    
    this.socket.rcnOutput.combineWith(this.socket.componentListInput)    

    if(this.http_api_module)
    {
      this.socket.rcnOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.rcnOutput.combineWith(this.socket.userInputFlowInput)
    }
  }
}